import * as React from 'react';
import PropTypes from 'prop-types';
import Dropzone, { DropEvent, DropzoneRef, FileRejection } from 'react-dropzone';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Button } from 'reactstrap';
import { useRef } from 'react';
function Attachments(props: any) {
    const {
        config,
        onDropRejected,
        onDrop,
        onCancel,
        fileError,
        files,
        removeFile
    }: {
			config: any,
			onDropRejected: (fileRejections: FileRejection[], event: DropEvent) => void;
			onDrop: (anyFiles: any[], fileRejections: FileRejection[], event: DropEvent) => void,
        onCancel: Function,
        fileError: String,
        files: any[],
        removeFile: Function
    } = props;

	const dropzoneRef = useRef<any>(null);

	return (
		<Col lg="5" className="attachments">
			<Col lg="12">
				<div className="dropzone">
					<Dropzone
						ref={dropzoneRef}
						accept={{
							'text/plain': ['.txt'],
							'application/msword': ['.doc'],
							'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
							'application/pdf': ['.pdf']
						}}
						maxSize={config.maxAppointmentAttachmentSize}
						onDropRejected={onDropRejected}
						onDrop={onDrop}
					//onFileDialogCancel={onCancel.bind(this)}
					//hidden = "true"
					>
						{({ getRootProps, getInputProps }) => (
							<div {...getRootProps()}
								style={{ "border": "dotted 2px #c0c0c0", "height": "8.7em", "padding": "10px" }}>
								<input {...getInputProps()} />
								<p>Optionally, drag and drop files here to upload.<br /><br />Accepted file types: .txt .doc .docx .pdf </p>
							</div>
						)}
					</Dropzone>
					<Button style={{ "marginTop": "5px", "marginRight": "5px" }} color="primary" type="button" onClick={() => { dropzoneRef.current?.open() }}>Choose File</Button>
					<Button style={{ "marginTop": "5px" }} onClick={() => { onCancel() }}>Clear</Button>
				</div>
			</Col>
			<Col lg="4">
				{fileError !== null &&
					<div><span style={{ "color": "red" }}>* {fileError}</span></div>
				}
				<ul>
					{
						files.map(f =>
							<div key={f.name}>
								<li><span>{f.name} - {f.size} bytes </span><FontAwesomeIcon className="hand" style={{ "color": "#717171", "fontSize": "18px", "marginLeft": "4px" }} id="trashFile" icon={faTrashAlt} size="lg" onClick={() => { removeFile(f) }} /></li>
							</div>
						)}
				</ul>
			</Col>
		</Col>
	);
}
export default Attachments;